import { ShieldCheck, MessageSquareText } from "lucide-react";
import { waLink } from "../config/business";
import { useLanguage } from "../i18n/LanguageContext";
import { Reveal } from "./shared";

const Trust = () => {
  const { t } = useLanguage();

  return (
    <section data-testid="trust-section" className="section-glow">
      <div className="relative mx-auto max-w-6xl px-5 sm:px-8 py-20 sm:py-28">
        <Reveal>
          <div className="card-elevated relative overflow-hidden rounded-3xl p-8 sm:p-12 lg:p-14">
            <div className="pointer-events-none absolute -right-24 -top-24 h-72 w-72 rounded-full bg-amber-400/10 blur-3xl" />
            <div className="pointer-events-none absolute -bottom-24 -left-16 h-64 w-64 rounded-full bg-blue-600/15 blur-3xl" />
            <div className="relative grid items-center gap-10 lg:grid-cols-5">
              <div className="lg:col-span-3">
                <span className="icon-tile mb-6 flex h-14 w-14 items-center justify-center rounded-2xl text-amber-400">
                  <ShieldCheck className="h-7 w-7" strokeWidth={2} />
                </span>
                <h2 data-testid="trust-title" className="font-heading text-3xl sm:text-4xl lg:text-5xl font-bold tracking-[-0.03em] leading-[1.08] text-slate-50">
                  {t.trust.title}
                </h2>
                <p data-testid="trust-body" className="mt-6 max-w-2xl text-base sm:text-lg leading-relaxed text-slate-300">{t.trust.body}</p>
              </div>
              <div className="lg:col-span-2 lg:justify-self-end">
                <a
                  data-testid="trust-whatsapp-cta"
                  href={waLink(t.hero.waMessage)}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-wa w-full rounded-2xl px-8 py-5 text-lg lg:w-auto"
                >
                  <MessageSquareText className="h-5 w-5" strokeWidth={2.5} />
                  {t.trust.cta}
                </a>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default Trust;
